module.exports = __webpack_public_path__ + "static/media/bot-bg-low.2e870de0.png";